import React, { Component } from 'react';
import { connect } from 'react-redux';
import style from './style.css';
import CSSModule from 'react-css-modules';
import { Link, browserHistory } from 'react-router';
import logo from './logo.png';
import cookie from 'react-cookie';

class Header extends Component {
    constructor(props){
        super(props);
    }
    componentWillReceiveProps(nextProps) {
    }
    renderNav(url, name){
        const { path } = this.props;
        const routes = path.split('/');
        if( routes && routes.length > 1 ) var page = routes[1];
        const active = url === page ? 'active': ''; 

        return ( <Link to={ "/"+ url } styleName={active} >{ name }</Link>);
    }
    render(){
        const { user, lastPoints } = this.props;

        const logout = (e) => {
            cookie.remove('token', { path: '/'});
            cookie.remove('user_id', { path: '/'});
            window.location.reload()
        }

        const userType = user.level === 2 ? 'VIP': '一般';

        return(
            <header>
                <div styleName="container">
                    <Link to="/applyMain"><img src={logo} alt="武林文創" /></Link>
                    { user && user.hasOwnProperty('id') &&
                    <nav>
                        <div styleName="navigation">
                            { this.renderNav('applyMain', '報名') }
                            { this.renderNav('recharge', '儲值') }
                            { this.renderNav('member', '會員') }
                            { this.renderNav('manage', '管理') }
                        </div>
                    
                        <dl styleName="user">
                            <a href="/profile"><dd>{ user.name }</dd></a>
                            <dd>{ userType }</dd>
                            <dd>{ lastPoints }點</dd>
                            <dd onClick={logout}>登出</dd>
                        </dl>
                    </nav>
                    }
                </div>
            </header>
        );
    }
}

const mapStateToProps = state => {
	return { 
        user: state.data.user,
        lastPoints: state.data.lastPoints
    };
}

export default connect(mapStateToProps, { })(CSSModule(Header,style));



/** WEBPACK FOOTER **
 ** ./src/container/header/index.js
 **/